module.exports = __webpack_public_path__ + "img/hexels.fc31678b.svg";